/* eslint-disable no-useless-constructor */
import Axios from "./axios.service";

export class EmployeeService {
  constructor() {}
  static async listEmployees() {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/employee-management/list-employees`,
    });
  }

  static async listAdministratorsById(id) {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/employee-management/list-employees?pay-center-id=${id}`,
    });
  }

  static async editEmployee(payload) {
    return Axios({
      method: "PUT",
      url: `web-services/api/v6/services/admin/usermanagement/edit-employee/${payload.userId}`,
      data: payload,
    });
  }

  static async suspendEmployee(userId) {
    return Axios({
      method: "PUT",
      url: `/web-services/api/v6/services/admin/generic-user-management/deactivate-user-account/${userId}`,
    });
  }

  static async activateEmployee(userId) {
    return Axios({
      method: "PUT",
      url: `/web-services/api/v6/services/admin/generic-user-management/activate-user-account/${userId}`,
    });
  }

  static async addEmployee(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/employee-management/add-employee`,
      data: payload,
    });
  }

  static async addRole(payload) {
    return Axios({
      method: "PUT",
      url: `web-services/api/v6/services/admin/employee-management/add-role`,
      data: payload,
    });
  }

  static async allowDuplicateLogin(userId) {
    return Axios({
      method: "PUT",
      url: `/web-services/api/v6/services/admin/generic-user-management/allow-duplicate-login/${userId}`,
    });
  }

  static async allowPasswordReset(userId) {
    return Axios({
      method: "PUT",
      url: `/web-services/api/v6/services/admin/generic-user-management/reset-user-password/${userId}`,
    });
  }

  static async disableOtp(userId) {
    return Axios({
      method: "PUT",
      url: `/web-services/api/v6/services/admin/generic-user-management/request-user-otp/${userId}/false`,
    });
  }

  // ADDED PAYCENTER HERE CAUSE I WAS IN A HURRY
  // YOU CAN REMOVE IT AND PUT IT NTO ANOTHER SERVICES LATER ON
  static async addInternalPaycenter(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/pay-centre-management/add-internal-pay-centre`,
      data: payload,
    });
  }

  static async verifyCustomer(userId) {
    return Axios({
      method: "GET",
      url: `/web-services/api/v6/services/admin/customer-management/verify-customer/${userId}`,
    });
  }
}
